interface Props {
  label?: string;
  variant?: 'card' | 'hero' | 'thumb' | 'banner' | 'compact';
  /** If provided AND non-null, renders an <img> instead of the placeholder. */
  src?: string | null;
  /** Optional class to override the aspect-ratio set by variant. */
  aspectClass?: string;
}

const SIZES: Record<NonNullable<Props['variant']>, string> = {
  card: 'aspect-[4/3]',
  hero: 'aspect-[16/9]',
  thumb: 'aspect-square',
  banner: 'aspect-[2/1]',
  compact: 'aspect-[5/2]',
};

export function PlaceholderRender({
  label = 'Render pending',
  variant = 'card',
  src,
  aspectClass,
}: Props) {
  const sizeClass = aspectClass ?? SIZES[variant];
  if (src) {
    return (
      <img
        src={src}
        alt={label}
        loading="lazy"
        className={`${sizeClass} w-full object-cover bg-vari-beige`}
      />
    );
  }
  return (
    <div
      className={`${sizeClass} w-full bg-gradient-to-br from-vari-beige to-vari-sage border border-vari-soft-gray flex items-center justify-center text-vari-gray text-sm select-none overflow-hidden relative`}
    >
      <div className="absolute inset-0 opacity-20" aria-hidden>
        <svg viewBox="0 0 100 100" className="w-full h-full" preserveAspectRatio="none">
          <defs>
            <pattern id="grid" width="8" height="8" patternUnits="userSpaceOnUse">
              <path d="M 8 0 L 0 0 0 8" fill="none" stroke="white" strokeWidth="0.4" />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#grid)" />
        </svg>
      </div>
      <span className="relative font-medium tracking-[0.2em] uppercase text-xs text-vari-navy">
        {label}
      </span>
    </div>
  );
}
